<template>
  <div class="awardContainer" :style="bgStyle">
    <div class="amount">{{ awardData.totalAmount }}</div>
    <div class="label">积分</div>
  </div>
</template>

<script>
export default {
  props: {
    awardData: {
      type: Object,
      required: true
    }
  },
  computed: {
    bgStyle() {
      return {
        background: `center / cover no-repeat url("${this.awardData.imgUrl}")`
      };
    }
  }
};
</script>

<style lang="less" scoped>
.awardContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #be430d;
  text-align: center;
  text-shadow: 0px 1px 1px 0px rgba(255, 253, 245, 0.86);

  .amount {
    font-size: 1.68em;
    // font-family: Source Han Sans SC Bold, Source Han Sans SC Bold-Bold;
    font-family: 'Alibaba Zhixing';
    font-weight: 700;
    line-height: 1;
  }

  .label {
    font-size: 1em;
    font-family: Source Han Sans SC Medium, Source Han Sans SC Medium-Medium;
    font-weight: 500;
  }
}
</style>
